// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"1873c25b","150":"1396bf6e","151":"3173009b","234":"0caf526e","438":"19c835e1","549":"179f7d81","646":"10d49f4f","708":"c42e5cb3","787":"d612aca3","789":"0ae34a15","873":"22f8acdc","886":"d5ed68b0","898":"8e1d48d0"}[chunkId] + ".chunk.js";
};